import { onUserTaskTemplateActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { DefaultTaskActivityCard } from "./DefaultTaskActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  defaultTaskId: number
  config: server.dto.ActivityPanelConfig
}

export const DefaultTaskActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  return <ActivityPanel<server.dto.UserTaskTemplateActivity>
    activityKey="userTaskTemplate"
    itemId={props.defaultTaskId}
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.UserTaskTemplate.ListActivity({ itemId: props.defaultTaskId, page, perPage })}
    renderActivity={(activity => <DefaultTaskActivityCard key={activity.activityId} activity={activity} />)}
    onActivityRegisterFn={onUserTaskTemplateActivity}
    onActivity={(activity) => {
      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}
